import { Link } from 'react-router-dom'
import { ShieldOff, Compass } from 'lucide-react'

function ErrorScreen({
  icon,
  code,
  title,
  message,
}: {
  icon: React.ReactNode
  code: string
  title: string
  message: string
}) {
  return (
    <div className="flex min-h-dvh flex-col items-center justify-center gap-4 bg-background px-6 text-center">
      <span className="rounded-full bg-primary/10 p-5 text-primary" aria-hidden="true">
        {icon}
      </span>
      <p className="font-headline text-5xl font-bold text-primary">{code}</p>
      <h1 className="font-headline text-2xl font-bold text-secondary">{title}</h1>
      <p className="max-w-md text-on-surface-variant">{message}</p>
      <Link
        to="/"
        className="mt-2 rounded-lg bg-primary px-8 py-3 text-sm font-bold text-on-primary shadow-raised transition-all hover:bg-primary/90 active:scale-[0.98]"
      >
        Wróć do panelu głównego
      </Link>
    </div>
  )
}

export function NotFoundPage() {
  return (
    <ErrorScreen
      icon={<Compass size={32} />}
      code="404"
      title="Nie znaleziono strony"
      message="Adres, którego szukasz, nie istnieje lub został przeniesiony."
    />
  )
}

export function ForbiddenPage() {
  return (
    <ErrorScreen
      icon={<ShieldOff size={32} />}
      code="403"
      title="Brak dostępu"
      message="Twoja rola nie pozwala na wejście do tej sekcji. Jeśli uważasz, że to pomyłka, skontaktuj się z administratorem."
    />
  )
}
